import {getAlbums, getPhotos} from './../services/flickrServices'
import { push } from 'react-router-redux'
import { ROUTE_MEDIA_PHOTOS } from '../constants'


export const SET_ALBUMS = 'SET_ALBUMS'
export const SET_PHOTOS = 'SET_PHOTOS'

const setAlbums = (data) => {
  return { type: SET_ALBUMS, data }
}

const setPhotos = (album, data) => {
  return { type: SET_PHOTOS, album, data }
}


const getAlbumsSortByDate = (albums) => {
  return albums.sort((a, b) => {
    return new Date(b.primary_photo_extras.datetaken) - new Date(a.primary_photo_extras.datetaken)
  })
}

export const fetchAlbums = () => {
  return (dispatch) => {
    getAlbums()
      .then((data)=> {
      dispatch(setAlbums(getAlbumsSortByDate(data.photosets.photoset)))
    })
      .catch(dispatch(setAlbums([])))
  }
}

export const goToAlbum = (album) => {
  return (dispatch) => {
    getPhotos(album)
      .then((data)=> {
        dispatch(setPhotos(album, data.photoset))
      })
      .then(() => {
       dispatch(push(`${ROUTE_MEDIA_PHOTOS}/${album}`))
    })
  }
}





/** WEBPACK FOOTER **
 ** ./src/actions/photos.actions.js
 **/